import { Button, Dialog, Text } from '@noorden-insurtech/alba-design-system';
import { AlertTriangle } from 'lucide-react';
import type { ReactNode } from 'react';

interface UnderAnalysisInfoModalProps {
  isOpen: boolean;
  onClose: () => void;
  messages?: ReactNode[];
  confirmLabel?: string;
  onConfirm?: () => void;
}

export function UnderAnalysisInfoModal({
  isOpen,
  onClose,
  messages = [],
  confirmLabel = 'Entendi',
  onConfirm,
}: UnderAnalysisInfoModalProps) {
  return (
    <Dialog.Root open={isOpen} onOpenChange={onClose}>
      <Dialog.Backdrop />
      <Dialog.Positioner>
        <Dialog.Content className='w-[480px] max-w-[480px] rounded-[24px] p-6 shadow-xl'>
          <div className='flex flex-col items-start gap-8'>
            <Dialog.Header className='w-full p-0'>
              <Dialog.Title className='w-full'>
                <div className='flex w-full items-center justify-between gap-3'>
                  <div className='flex items-center gap-2'>
                    <AlertTriangle className='h-6 w-6 text-alba-error-red-500' />
                    <Text className='text-lg font-bold text-alba-black-500'>
                      Cotação enviada para análise
                    </Text>
                  </div>
                  <Dialog.CloseButton onClick={onClose} />
                </div>
              </Dialog.Title>
            </Dialog.Header>

            <Dialog.Body className='w-full px-6 py-0'>
              <div className='flex flex-col items-start gap-3'>
                <Text className='text-sm text-alba-gray-600'>
                  A subscrição automática retornou mensagens pendentes. A
                  cotação foi encaminhada para análise e o cálculo não foi
                  executado.
                </Text>

                {messages.length > 0 && (
                  <ul className='flex w-full list-disc flex-col gap-1 pl-5'>
                    {messages.map((message, index) => (
                      <li
                        key={index}
                        className='font-montserrat text-sm text-alba-black-500'
                      >
                        {message}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </Dialog.Body>

            <Dialog.Footer className='w-full p-0 px-6'>
              <div className='flex w-full items-center justify-end gap-6'>
                <Button
                  variant='primary'
                  size='md'
                  onClick={onConfirm ?? onClose}
                >
                  {confirmLabel}
                </Button>
              </div>
            </Dialog.Footer>
          </div>
        </Dialog.Content>
      </Dialog.Positioner>
    </Dialog.Root>
  );
}
